<template>
  <div class="sidebar-profile">
    <div class="user-info">
      <div class="user-avatar">
        <img
          v-if="currentUser?.avatar"
          :src="currentUser.avatar"
          alt="User Avatar"
          @click="router.push('/profile/info')"
        />

        <img v-else src="@/assets/images/user-icon.png" class="ms-2 photo" @click="router.push('/profile/info')" />
      </div>
      <div class="user-details">
        <p class="account-label">Аккаунт</p>
        <a :href="currentUser.email" class="user-email">{{ currentUser.email }}</a>
      </div>
    </div>
    <div class="divider"></div>
    <nav class="menu mt-2">
      <ul>
        <li v-for="(item, index) in sidebarList" :key="index">
          <router-link :to="item.link" class="menu-link px-4 d-flex align-items-center" active-class="active">
            <div class="menu-icon-container">
              <img :src="item.icon" />
              <span v-if="item.link === '/profile/basket' && cartCount > 0" class="icon-badge">
                {{ cartCount }}
              </span>
            </div>

            <span class="ms-4" translate="yes">{{ item.title }}</span>
          </router-link>
        </li>
        <li>
          <a class="menu-link px-4" active-class="active" @click="logout()">
            <img src="@/assets/images/icons/logout.svg" class="me-4" /> Выйти
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
  import { defineComponent, ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { sidebarList } from '@/models/sidebar';

  export default defineComponent({
    name: 'ProfileSidebar',
    setup() {
      const fileInput = ref(null);
      const router = useRouter();
      const store = useStore();
      const currentUser = computed(() => store.state.user.user);
      const cartCount = computed(() => store.state.user.cartItems);

      const logout = async () => {
        await store.dispatch('auth/logout');
        router.push('/');
      };

      return {
        fileInput,
        currentUser,
        cartCount,
        sidebarList,
        router,
        logout,
      };
    },
  });
</script>

<style lang="scss">
  @import '@/assets/styles/profile/sidebar';

  .sidebar-badge {
    min-width: 20px;
    margin-left: 2px;
    padding: 2px 8px;

    color: white;
    font-weight: 700;
    font-size: 11px;
    text-align: center;

    background-color: #ff2d87;
    border-radius: 10px;

    animation: pop-in 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

  @keyframes pop-in {
    0% {
      transform: scale(0.5);
      opacity: 0;
    }

    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  .menu-icon-container {
    position: relative;

    display: flex;
    align-items: center;
    width: 24px;

    img {
      width: 24px;
      height: 24px;
    }

    .icon-badge {
      position: absolute;
      top: -8px;
      right: -10px;

      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 18px;
      height: 18px;
      padding: 0 4px;

      color: white;
      font-weight: 700;
      font-size: 10px;

      background-color: #ff2d87;
      border: 2px solid #fff;
      border-radius: 50%;
      box-shadow: 0 2px 4px rgb(0 0 0 / 10%);
    }
  }
</style>
